export enum CREATE_USER_FEEDBACK_FORM_FIELDS {
  RATING = "rating",
  DESCRIPTION = "description",
  EMAIL = "email",
  FILE = "file",
  RECAPTCHA = "recaptcha",
}

export const MESSAGE_ZONE_USER_FEEDBACK_FORM = "userFeedbackForm";
